import React from "react";
import Button from "./Button";
import ParaText from "./ParaText";

export default function ContactBanner({ children }) {
  return (
    <div className="contactBanner__wrapper">
      <div className="contactBanner">
        <ParaText className="aboutsection__paraText">
          Have a Project In Mind
        </ParaText>
        <h3 className="contactBanner__heading">Let Me Help You</h3>
        <Button btnLink="/contact" btnText="Contact Now" outline="#f33501" />
      </div>
    </div>
  );
}
